import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalFormat'
})
export class DecimalFormatPipe implements PipeTransform {
  transform(value: any, decimalPlaces:number = 4): unknown {
    let parsedValue = parseFloat(value);
    if(decimalPlaces == 0) {
      parsedValue = Math.round(parseFloat(value) - 0.0001);
    }
    
    const roundedValue = parsedValue.toFixed(decimalPlaces);
    // Format with a single comma for thousands separator
    let formattedNumber:any = roundedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    let number;
    if(formattedNumber && formattedNumber.includes('.')) {
      let leftSide = formattedNumber.split(".")[0];
      let rightSide = formattedNumber.split('.')[1].replace(",","");
      number = leftSide+"."+rightSide;
    } else {
      number = formattedNumber;
    }
    return number;
  }
}